<template>
  <v-subheader class="text-caption pa-0" style="height: auto;" v-on="$listeners">
    <a class="text-decoration-underline link--text font-italic" v-text="$i18n.t(translationPath)"> </a>
  </v-subheader>
</template>

<script>
export default {
  name: 'LinkUnderlined',
  props: {
    translationPath: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
